import { render } from "./Car.vue?vue&type=template&id=4880e8ec"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Car.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4880e8ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4880e8ec', __exports__)) {
    api.reload('4880e8ec', __exports__)
  }
  
  module.hot.accept("./Car.vue?vue&type=template&id=4880e8ec", () => {
    api.rerender('4880e8ec', render)
  })

}


export default __exports__